import { Tabs, Empty } from 'antd';
import styled from '@emotion/styled';
import { useEffect, useMemo } from 'react';
import { useLatest, useMemoizedFn } from 'ahooks';
import TimeCard from './render/TimeCard';
import useTimeRange from './useTimeRange';
import { usePresetTimes } from '../../atom/presetTime';
import { useTranslate } from '@tolgee/react';

type PresetTimeImplProps = {
  ids: number[];
  onCardSelect: (id: number) => void;
};

function PresetTimeImpl(props: PresetTimeImplProps) {
  const { t } = useTranslate();
  const { ids, onCardSelect } = props;
  const idsRef = useLatest(ids);
  const [open, instance] = useTimeRange();
  const { data } = usePresetTimes();
  const effective = useMemo(() => {
    return data?.filter((e) => e.isEffective) || [];
  }, [data]);
  const ineffective = useMemo(() => {
    return data?.filter((e) => !e.isEffective) || [];
  }, [data]);

  useEffect(() => {
    for (let i = 0; i < idsRef.current.length; i++) {
      const id = idsRef.current[i];
      const item = effective.find((e) => e.id === id);
      if (!item) {
        onCardSelect(id);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [effective]);

  const renderList = useMemoizedFn((list: Knowledge.PresetTime[], ineffective) => {
    return list?.length ? (
      <TabPaneContent>
        {list.map((item) => {
          return (
            <TimeCard
              key={item.id}
              selected={ids.includes(item.id)}
              open={open}
              noHoverStyle={ineffective}
              data={item}
              ineffective={ineffective}
              onClick={() => !ineffective && onCardSelect(item.id)}
            />
          );
        })}
      </TabPaneContent>
    ) : (
      <TabPaneContent>
        <Empty style={{ margin: '30px auto' }} image={Empty.PRESENTED_IMAGE_SIMPLE} />
      </TabPaneContent>
    );
  });
  return (
    <Container>
      {instance}
      <TabHeader>
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab={t('marketing.生效中')} key="1">
            {renderList(effective, false)}
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('knowledge.已失效')} key="2">
            {renderList(ineffective, true)}
          </Tabs.TabPane>
        </Tabs>
      </TabHeader>
    </Container>
  );
}

const Container = styled.div`
  background: #f7f9fa;
  .ant-tabs-nav {
    margin-bottom: 0 !important;
  }
`;

const TabHeader = styled.div`
  background: #fff;
  .ant-tabs-nav-wrap {
    padding: 0 25px;
  }
`;

const TabPaneContent = styled.div`
  padding: 16px;
  height: 347px;
  overflow: auto;
  background: #f7f9fa;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export default PresetTimeImpl;
